import { render, staticRenderFns } from "./ButtonsActions.vue?vue&type=template&id=6f55a34c&scoped=true&"
import script from "./ButtonsActions.vue?vue&type=script&lang=js&"
export * from "./ButtonsActions.vue?vue&type=script&lang=js&"
import style0 from "./ButtonsActions.vue?vue&type=style&index=0&id=6f55a34c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f55a34c",
  null
  
)

export default component.exports